/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./enter.vue?vue&type=template&id=32bbab64&scoped=true&"
import script from "./enter.vue?vue&type=script&lang=ts&"
export * from "./enter.vue?vue&type=script&lang=ts&"
import style0 from "./enter.vue?vue&type=style&index=0&id=32bbab64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bbab64",
  null
  
)

export default component.exports